import { Controller } from '@hotwired/stimulus';
import { analytics } from '@infakt/analytics';

const ADVERT = { placement: 'zus_dra_popover', campaign: 'zus_dra_upsell' };
const GAP = 4;

export default class extends Controller {
  static targets = ['tail'];
  static values = { settlementMonth: String };

  connect() {
    this.element.parentElement.classList.add('relative');
    this.element.classList.remove('hidden');
    this.place();

    analytics.track('upsell_advert_viewed', this.advert);
  }

  place() {
    const container = this.element.parentElement.getBoundingClientRect();
    const box = this.element.parentElement.querySelector('[data-kind="ife_xml"]')?.getBoundingClientRect();

    this.tailTarget.classList.toggle('hidden', !box);

    Object.assign(this.element.style, {
      top: box ? `${box.top + box.height / 2 - container.top}px` : '',
      right: box ? `${container.right - box.left + GAP}px` : '',
      transform: box ? 'translateY(-50%)' : '',
    });
  }

  click() {
    analytics.track('upsell_advert_clicked', this.advert);
  }

  close() {
    analytics.track('upsell_advert_closed', this.advert);
  }

  get advert() {
    return { ...ADVERT, settlement_month: this.settlementMonthValue };
  }
}
